export default __webpack_public_path__ + "images/Icon awesome-globe-africa.1d37662e4c5ffb8a5b49d29ff74eaba6.svg";